/************************************************************
 Physiotherapy Namespace
 ************************************************************/

window.physiotherapy = {
    // Private Variables
    _row:null,
    _action:null,
    _callback:null,
    // Execute Action
    executeAction:function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        physiotherapy._action = action;
        physiotherapy._row = row;
        physiotherapy._callback = callback;

        debug.log('physiotherapy', action);
        debug.log('physiotherapy - row', row);

        debug.log('physiotherapy wfId', wfId);
        debug.log('physiotherapy actionId', actionId);
        // Requisition
        if (wfId == 7) {
            // Schedule external requisition
            if(actionId == 25){
                physiotherapy.openScheduleRequisitionExternal(physiotherapy.scheduleRequisitionExternalModalHandler);
            }
            // Print requisition
            else if(actionId == 23){
                var url = "/physiotherapy/requisition_sheet?requisition_id="+row.requisition_id+"&task_id="+action.task_id+"&patient_id="+row.patient_id;

                Hades.showDocument(url);
                physiotherapy._callback(true, physiotherapy._action, physiotherapy._row);
            }
            // Cancel Physiotherapy Requisition
            else if (actionId == 3) {
                var params = {
                    task_id:physiotherapy._action.task_id,
                    wf_id:physiotherapy._action.wf_id,
                    wf_status_id:physiotherapy._action.to_state_id,
                    wf_action_id:physiotherapy._action.wf_action_id};

                $.get('/modal/generic_reason_window', params, null, "html")
                    .done(function (data, status, xhr) {
                        Hades.checkIfUserIsAuthorized(data, status, xhr);

                        $.fancybox({content:data, autoScale:true, autoDimensions:true});

                        $('#generic-reason-modal-ct').bind('genericReasonConfirmed', physiotherapy.cancelPhysiotherapyRequisition);

                        Hades.hideLoading();
                    })
                    .fail(function (xhr, status, error) {
                        Hades.showError(error, xhr.responseText, xhr, status, error);
                        Hades.hideLoading();
                    });

            }
            // Schedule Physiotherapy
            else if (actionId == 6) {
                Hades.loadShortcut(16, {id:physiotherapy._row.task_id, wf_id:physiotherapy._row.wf_id, type:'physiotherapy'});
            }
            // Reopen Physiotherapy
            else if (actionId == 14) {

                physiotherapy.reopenPhysiotherapyHandler();


            }
            // Discontinue Physiotherapy
            else if (actionId == 8) {
                physiotherapy.openReason(physiotherapy.discontinuePhysiotherapyReasonModalHandler);
            }
            // Finalize Physiotherapy
            else if (actionId == 12) {
                physiotherapy.openReason(physiotherapy.finalizePhysiotherapyReasonModalHandler);
            }
            else {
                physiotherapy.executeGenericAction();
            }
        }
        // Session Appointment
        else if (wfId == 1) {
            debug.log('physiotherapy');
            // Cancel Session
            if (actionId == 3) {
                physiotherapy.openReason(physiotherapy.cancelReasonModalHandler);
            }
            else if (actionId == 15) {
                appointmentNS.executeAction(this._action, this._row, this._callback);
            }
            // Reschedule Session
            else if (actionId == 2) {
                physiotherapy.openScheduler();
            }

            if (actionId == 16) {
                physiotherapy.openReason(physiotherapy.undoPatientAbsenceReasonModalHandler);
            }

            // Other actions
            else {
                physiotherapy.executeGenericAction();
            }
        }
        // Session
        else if (wfId == 8) {
            // Cancel Session
            if (actionId == 3) {
                physiotherapy.openReason(physiotherapy.cancelReasonModalHandler);
            }
            else if (actionId == 15 || actionId == 74) {
                appointmentNS.executeAction(this._action, this._row, this._callback);
            }
            // Reschedule Session
            else if (actionId == 2) {
                physiotherapy.openScheduler();
            }
            // Undo Patient Arrival
            else if (actionId == 17) {
                physiotherapy.openReason(physiotherapy.undoPatientArrivalReasonModalHandler);
            }
            // Undo Patient Absence
            else if (actionId == 16) {
                physiotherapy.openReason(physiotherapy.undoPatientAbsenceReasonModalHandler);
            }
            //Patient Absence
            else if ((wfId == 1 || wfId == 2 || wfId == 8) && actionId == 15) {
                appointmentNS.executeAction(episode._action, episode._row, episode._callback);
            }
            //Undo Start Episode
            else if (actionId == 99) {
                physiotherapy.openReason(physiotherapy.undoStartEpisode)
            }
            //Undo Finalize Episode
            else if (actionId == 100) {
                physiotherapy.openReason(physiotherapy.undoFinalizeEpisode)
            }
            // Other actions
            else {
                physiotherapy.executeGenericAction();
            }
        } else if (wfId == 2 ) {
            if (actionId == 16) {
                physiotherapy.openReason(physiotherapy.undoPatientAbsenceReasonModalHandler);
            } else if (actionId == 74) {
                appointmentNS.executeAction(this._action, this._row, this._callback);
            } else if (actionId == 18) {
                physiotherapy.openReason(physiotherapy.undoPatientArrivalReasonModalHandler);
            }
            //Undo Start Episode
            else if (actionId == 99) {
                physiotherapy.openReason(physiotherapy.undoStartEpisode)
            }
            //Undo Finalize Episode
            else if (actionId == 100) {
                physiotherapy.openReason(physiotherapy.undoFinalizeEpisode)
            }
        }
    },
    // Execute Generic Action
    executeGenericAction:function () {
        workflow.executeAction(physiotherapy._action, physiotherapy._callback, physiotherapy._row);
    },
    // Open Reason
    openReason:function (callback) {

        debug.log("passei aqui");

        var params = {
            task_id:physiotherapy._action.task_id,
            wf_id:physiotherapy._action.wf_id,
            wf_status_id:physiotherapy._action.to_state_id,
            patient_type_id:physiotherapy._row.patient_type_id,
            wf_action_id:physiotherapy._action.wf_action_id};

        if (params.patient_type_id == -1) {
            bootbox.alert('Necessário definir o tipo de utente para finalizar o processo');
            return false;
        }

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
            });
    },

    // Reopen Physiotherapy
    reopenPhysiotherapyHandler:function () {

        $.getJSON('/treatment/check_process_month_entity_invoiced', {task_id: physiotherapy._action.task_id, wf_id: physiotherapy._action.wf_id})
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                debug.log('check_entity_invoiced', data);

                if (data.length > 0){
                    var all_dates = '';
                    $.each(data, function( index, value ) {
                        debug.log(index, value);
                        if (index == 0){
                            all_dates = value.sale_transaction_date_desc;
                        }else{
                            all_dates = all_dates + ' | ' + value.sale_transaction_date_desc;
                        }

                    });

                    if (data[0].actual_month_in_lot === 't') {
                        bootbox.alert(GlobalTranslations['APP_LABEL.2455']);
                    } else if (data[0].invoice_has_credit_note === 'f') {
                        bootbox.alert(GlobalTranslations['APP_LABEL.TREATMENT_ALREADY_INVOICED'].replace('#sale_transaction_date#', all_dates))
                    } else {
                        bootbox.confirm(data[0].reopen_message.replace('#sale_transaction_date#', all_dates), function (success) {
                            Hades.showLoading();

                            if (success) {

                                physiotherapy.openReason(physiotherapy.reopenPhysiotherapy);

                            } else {
                                Hades.hideLoading();
                                $.fancybox.close(true);
                                //Hades.goToPreviousScreen();
                            }
                        });
                    }
                }
                else {

                    $.getJSON('/billing/entities/verify_credential_added_to_lot', {task_id: physiotherapy._action.task_id, wf_id: physiotherapy._action.wf_id})
                        .done(function (data, status, xhr) {
                            Hades.checkIfUserIsAuthorized(data, status, xhr);
                            if (!data) {

                                physiotherapy.openReason(physiotherapy.reopenPhysiotherapy);

                            }
                            else {
                                bootbox.alert(GlobalTranslations['APP_LABEL.2455']);
                                $.fancybox.close(true);
                                Hades.hideLoading();
                            }

                        })
                        .fail(function (xhr, status, error) {
                            Hades.showError();
                            Hades.hideLoading();
                        });


                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
            });
    },
    reopenPhysiotherapy: function (evt, data){

        $.fancybox.close(true);

        var params = {
            task_id:physiotherapy._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:physiotherapy._row.wf_id,
            wf_status_id:physiotherapy._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/physiotherapy/reopen_physiotherapy', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
                } else {
                    Hades.hideLoading();
                    physiotherapy._callback(true, physiotherapy._action, physiotherapy._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
            });
    },
    // Discontinue Physiotherapy
    discontinuePhysiotherapyReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:physiotherapy._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:physiotherapy._row.wf_id,
            wf_status_id:physiotherapy._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/physiotherapy/discontinue_physiotherapy', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
                } else {
                    physiotherapy._callback(true, physiotherapy._action, physiotherapy._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
            });
    },
    // Finalize Physiotherapy
    finalizePhysiotherapyReasonModalHandler:function (event, data) {
        //$.fancybox.close(true);

        var params = {
            task_id:physiotherapy._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:physiotherapy._row.wf_id,
            wf_status_id:physiotherapy._row.wf_status_id,
            wf_action_id:data.actionId};

        $.getJSON('/treatment/check_process_month_entity_invoiced', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                /*var process_month_end_date = new Date(params.date.substr(6, 4),
                    params.date.substr(3, 2),
                    '01');
*/
                var process_month_end_date = params.date.substr(6, 4) +
                    params.date.substr(3, 2) +
                    '01';

                debug.log('check_entity_invoiced', data, params.date, params.hour);
                debug.log(
                    params.date.substr(6, 4),
                    params.date.substr(3, 2),
                    '01',
                    process_month_end_date
                );

                if (data.length > 0){
                    //compare process date (year_month) for finalize with sale_transaction (year_month); process end_date need to be after sale_transaction finalized_date;
                    //var st_date = '';
                    debug.log(process_month_end_date,
                        (   data[data.length-1].sale_transaction_date_desc.substr(6, 4) +
                            data[data.length-1].sale_transaction_date_desc.substr(3, 2) +
                            '01'
                        ),
                        data[data.length-1].sale_transaction_date_desc );

                    if ( (data[data.length-1].sale_transaction_date_desc.substr(6, 4) +
                            data[data.length-1].sale_transaction_date_desc.substr(3, 2) +
                            '01'
                        ) >= process_month_end_date ){
                        //DO NOT FINALIZE

                        bootbox.alert(data[0].finalized_message.replace('#sale_transaction_date#', data[data.length-1].sale_transaction_date_desc),
                            function(){});

                    }else{
                        //FINALIZE
                        $.fancybox.close(true);
                        physiotherapy.finalizePhysiotherapy(params);

                        //IF ASKED TO PUT THAT SPECIFIC "exception message", make a new "else if" with this code.
                        //check if is the same month of the choosen end_date
                        /*$.each(data, function( index, value ) {

                            var st_date = value.sale_transaction_date_desc.substr(6, 4) +
                                value.sale_transaction_date_desc.substr(3, 2) +
                                '01';

                            debug.log(index, value, process_month_end_date, st_date);

                            if (process_month_end_date == st_date){
                                bootbox.alert('O processo já foi facturado no mês da data seleccionada, a data de fim terá que ser superior.');
                            }else{
                                //all_dates = all_dates + ' | ' + value.sale_transaction_date_desc;
                            }

                        });*/
                    }
                }
                else {
                    $.fancybox.close(true);
                    physiotherapy.finalizePhysiotherapy(params);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
            });

    },

    finalizePhysiotherapy: function(params, callback){
        $.post('/physiotherapy/finalize_physiotherapy', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    //physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
                } else {
                    if (callback){
                        callback();
                    } else if (physiotherapy._callback != null) {
                        physiotherapy._callback(true, physiotherapy._action, physiotherapy._row);
                    }
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
            });
    },
    // Cancel Task
    cancelReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:physiotherapy._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:physiotherapy._row.wf_id,
            wf_status_id:physiotherapy._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/episode/cancel_episode', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
                } else {
                    physiotherapy._callback(true, physiotherapy._action, physiotherapy._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
            });
    },
    undoPatientArrivalReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:physiotherapy._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:physiotherapy._row.wf_id,
            wf_status_id:physiotherapy._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/physiotherapy/undo_patient_arrival', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
                } else {
                    physiotherapy._callback(true, physiotherapy._action, physiotherapy._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
            });
    },
    undoStartEpisode: function(event, data) {
        Hades.showLoading();
        $.fancybox.close(true);

        var params = {
            task_id:physiotherapy._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:physiotherapy._row.wf_id,
            wf_status_id:physiotherapy._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/episode/undo_start_episode', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
                } else {
                    physiotherapy._callback(true, physiotherapy._action, physiotherapy._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
            });
    },
    undoFinalizeEpisode: function(event, data) {
        Hades.showLoading();
        $.fancybox.close(true);

        var params = {
            task_id:physiotherapy._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:physiotherapy._row.wf_id,
            wf_status_id:physiotherapy._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/episode/undo_finalize_episode', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
                } else {
                    physiotherapy._callback(true, physiotherapy._action, physiotherapy._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
            });
    },
    undoPatientAbsenceReasonModalHandler:function (event, data) {
        $.fancybox.close(true);
        debug.log('data', data, physiotherapy._row);

        var params = {
            task_id:physiotherapy._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:physiotherapy._row.wf_id,
            wf_status_id:physiotherapy._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/physiotherapy/undo_patient_absence', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
                } else {
                    physiotherapy._callback(true, physiotherapy._action, physiotherapy._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
            });
    },
    // Open Scheduler
    openScheduler:function () {
        Hades.showLoading();

        var params = {};
        params.wf_id = physiotherapy._action.wf_id;
        params.task_id = physiotherapy._action.task_id;
        params.date = physiotherapy._row.task_date_str;
        params.width = $(window).width();
        params.can_change_appointment_type = "0";
        params.can_change_financial_institution = "0";

        $.get('/calendar/calendar_pick_date', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data});

                $('#calendar-pick-date-ct').bind('dateSelected', physiotherapy.openSchedulerHandler);
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
    // Scheduler Handler
    openSchedulerHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {}
        params.professional_id = data.resource_id;
        params.professional_name = data.resource_desc;
        params.prev_date = data.prev_date;
        params.prev_hour = data.prev_hour;
        params.date = data.date;
        params.hour = data.hour;
        params.prev_professional_name = data.prev_professional_name;
        params.specialty_id = data.specialty_id;
        params.task_id = physiotherapy._action.task_id;
        params.wf_id = physiotherapy._action.wf_id;
        params.wf_status_id = physiotherapy._action.to_state_id;
        params.wf_action_id = physiotherapy._action.wf_action_id;

        $.get('/physiotherapy/confirm_session_reschedule', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', physiotherapy.rescheduleSession);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
    // Cancel Physiotherapy Requisition
    cancelPhysiotherapyRequisition:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:physiotherapy._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:physiotherapy._row.wf_id,
            wf_status_id:physiotherapy._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/physiotherapy/cancel_physiotherapy', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success) {
                    if(Hades.appArea() == 11){
                        Hades.reloadContextualHeader(true);
                    }

                    physiotherapy._callback(true, physiotherapy._action, physiotherapy._row);
                } else {
                    physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
    // Reschedule Session
    rescheduleSession:function (event, data) {
        $.fancybox.close(true);

        var params = {};
        params.wf_id = physiotherapy._row.wf_id;
        params.session_id = physiotherapy._row.task_id;
        params.resource_type_id = physiotherapy._row.resource_type_id;
        params.specialty_id = data.specialty_id;
        params.resource_id = data.professional_id;
        params.date = data.date + " " + data.hour;
        params.reason_id = data.reasonId;
        params.reason_desc = data.otherReason;

        $.post('/physiotherapy/reschedule_session', params, null, "json")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success) {
                    physiotherapy._callback(true, physiotherapy._action, physiotherapy._row);
                } else {

                    bootbox.alert(data.error);
                    physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
                }
            })
            .fail(function (xhr, status, error) {

                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
            });
    },
    // Open Scheduler
    openScheduleRequisitionExternal:function (callback) {
        var params = {
            task_id:physiotherapy._action.task_id,
            wf_id:physiotherapy._action.wf_id,
            wf_status_id:physiotherapy._action.to_state_id,
            wf_action_id:physiotherapy._action.wf_action_id};

        $.get('/physiotherapy/schedule_requisition_external_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#physiotherapy-requisition-schedule-ct').bind('scheduleRequisitionConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
            });
    },
    scheduleRequisitionExternalModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            requisition_id:data.requisition_id,
            requisition_date:data.requisition_date,
            requisition_hour:data.requisition_hour,
            provider_id:data.provider_id,
            financial_institution_id:data.financial_institution_id};

        $.post('/physiotherapy/schedule_requisition_external', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
                } else {
                    physiotherapy._callback(true, physiotherapy._action, physiotherapy._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
            });
    }
};